const state = {
    heatTreatmentInquireResultFields: [
        {
            key: "date",
            label: "日期",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "time",
            label: "時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "factory",
            label: "廠區",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "process",
            label: "製程",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "group",
            label: "組別",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "device",
            label: "機台",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        }
    ],
    heatTreatmentInquireResultItem: [],
    htWorkValueFields: [
        {
            key: "time",
            label: "時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "value_text",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp1",
            label: "焠火1區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp2",
            label: "焠火2區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp3",
            label: "焠火3區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp4",
            label: "焠火4區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp5",
            label: "焠火5區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_furn_temp6",
            label: "焠火6區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_furn_temp1",
            label: "回火1區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_furn_temp2",
            label: "回火2區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_furn_temp3",
            label: "回火3區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_furn_temp4",
            label: "回火4區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_furn_temp5",
            label: "回火5區T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_tank_temp",
            label: "焠火槽T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "dryer_cln_bf_temp",
            label: "冷卻槽T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cln_bf_temp",
            label: "前清洗T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cln_af_temp",
            label: "後清洗T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "carb_tank_temp",
            label: "發黑槽T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "dryer_temp",
            label: "發黑烘乾T",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cp1",
            label: "碳勢1",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cp2",
            label: "碳勢2",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cln_bf_conv_freq",
            label: "前洗變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "cln_af_conv_freq",
            label: "後洗變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_conv_freq",
            label: "焠火變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "quench_tank_elv_freq",
            label: "提升變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "dryer_conv_freq",
            label: "烘乾變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "carb_tank_elv_freq",
            label: "發黑變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
        {
            key: "tempering_conv_freq",
            label: "回火變頻",
            sortable: false,
            class: "font-family-dfyuanstd-w5",
        },
    ],
    htWorkValueItem: [],
    fromWorkOrderHistoryParams: {
        form: false,
        start: "",
        end: "",
        device: ""
    }
}
const getters = {
    get_heatTreatmentInquireResultFields: state => {
        return state.heatTreatmentInquireResultFields
    },
    get_heatTreatmentInquireResultItem: state => {
        return state.heatTreatmentInquireResultItem
    },
    get_htWorkValueFields: state => {
        return state.htWorkValueFields
    },
    get_htWorkValueItem: state => {
        return state.htWorkValueItem
    },
    get_fromWorkOrderHistoryParams: state => {
        return state.fromWorkOrderHistoryParams
    },
}
const actions = {
    set_heatTreatmentInquireResultFields(context, array) {
        context.commit('SET_HEATTREATMENTINQUIRERESULTFIELDS', array);
    },
    set_heatTreatmentInquireResultItem(context, array) {
        context.commit('SET_HEATTREATMENTINQUIRERESULTITEM', array);
    },
    clear_heatTreatmentInquireResultItem(context) {
        context.commit('CLEAR_HEATTREATMENTINQUIRERESULTITEM');
    },
    set_htWorkValueFields(context, array) {
        context.commit('SET_HTWORKVALUEFIELDS', array);
    },
    set_htWorkValueItem(context, array) {
        context.commit('SET_HTWORKVALUEITEM', array);
    },
    clear_htWorkValueItem(context) {
        context.commit('CLEAR_HTWORKVALUEITEM');
    },
    set_fromWorkOrderHistoryParams(context, array) {
        context.commit('SET_FROMWORKORDERHISTORYPARAMS', array);
    },
    clear_fromWorkOrderHistoryParams(context) {
        context.commit('CLEAR_FROMWORKORDERHISTORYPARAMS');
    },

}
const mutations = {
    SET_HEATTREATMENTINQUIRERESULTFIELDS(state, array) {
        state.heatTreatmentInquireResultFields = array;
    },
    SET_HEATTREATMENTINQUIRERESULTITEM(state, array) {
        state.heatTreatmentInquireResultItem = array;
    },
    CLEAR_HEATTREATMENTINQUIRERESULTITEM(state) {
        state.heatTreatmentInquireResultItem = [];
    },
    SET_HTWORKVALUEFIELDS(state, array) {
        state.htWorkValueFields = array;
    },
    SET_HTWORKVALUEITEM(state, array) {
        state.htWorkValueItem = array;
    },
    CLEAR_HTWORKVALUEITEM(state) {
        state.htWorkValueItem = [];
    },
    SET_FROMWORKORDERHISTORYPARAMS(state, obj) {
        state.fromWorkOrderHistoryParams = obj;
    },
    CLEAR_FROMWORKORDERHISTORYPARAMS(state) {
        state.fromWorkOrderHistoryParams = {
            form: false,
            start: "",
            end: "",
            device: ""
        };
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/heatTreatmentInquireResult.js